import React, {useState} from "react";
import {Button, Modal} from "semantic-ui-react";
import {PatientFile} from "../dashboard";
import agent from "../../agent";
import { textLabels } from "../../consts/textLabels";

interface Props {
    files: PatientFile[];
    onClose: (success: Boolean) => void;
}

const UserFileDeleteModal = (props: Props) => {
    const [saving, setSaving] = useState(false);

    return (
        <Modal
            onClose={() => props.onClose(false)}
            open={!!props.files}
            closeIcon>
            <Modal.Header>Удалить файл?</Modal.Header>
            <Modal.Content>
                <p>
                    {props.files.length === 1 ?
                        `Вы действительно хотите удалить отмеченный файл?`
                        : `Вы действительно хотите удалить отмеченные файлы (${props.files.length} шт.)?`
                    }
                </p>
            </Modal.Content>
            <Modal.Actions>
                <Button
                    content={textLabels.deleteButton}
                    disabled={saving}
                    onClick={async () => {
                        setSaving(true);
                        try {
                            for (const file of props.files) {
                                await agent.FileProvider.remove(file._id!.toString());
                            }
                            props.onClose(true);
                        } finally {
                            setSaving(false);
                        }
                    }}
                    positive
                />
                <Button
                    color={'grey'}
                    disabled={saving}
                    onClick={() => props.onClose(false)}>
                    {textLabels.cancelButton}
                </Button>
            </Modal.Actions>
        </Modal>);
}

export default UserFileDeleteModal;